/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Timeline, TimelineLite} from "gsap";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {DragonTribeBigWinCountUp} from "./DragonTribeBigWinCountUp";
import {DragonTribeBigWinView} from "./DragonTribeBigWinView";

export class DragonTribeBigWinController extends StepCountUpBigWinController {

    private _gameView:DragonTribeBigWinView;
    private _winCountUp:DragonTribeBigWinCountUp;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : true});

        this._gameView = new DragonTribeBigWinView();
        this._winCountUp = new DragonTribeBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);
        StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        if(this._gameData!.mode.indexOf("_AVALANCHE") > -1) {
            this._winLevel = -1;
        }
        let winRatios:number = data.currentWinRatio;
        if(this._gameData!.mode.indexOf("_AVALANCHE") > -1) {
            winRatios = data.currentBigWinWinRatio;
        }
        if(data && data.isEndBigWin) {
            for(let i:number = this._winRatios.length - 1; i >= 0; i--) {
                if(winRatios > this._winRatios[i].ratio) {
                    this._winLevel = i;
                    return;
                }
            }
            // if the winRation is exactly 15
            this._winLevel = 0;
        } else {
            this._winLevel = -1;
        }
    }

    protected hasWin():boolean {
        return ((this._gameData != null) && (<DragonTribeParsedGameData>this._gameData!).isEndBigWin && ((<DragonTribeParsedGameData>this._gameData!).singleWin === 0));
    }

    protected startWinPresentation():void {
        super.startWinPresentation();
        this._gameView.startWinPresentation();
    }

    protected playBigWinCountUp(level:number, duration:number):Timeline | null {
        let totalWin:number = (<DragonTribeParsedGameData>this._gameData!).avalancheTotalWin;
        const preTotalWin:number = (<DragonTribeParsedGameData>this._gameData!).avalancheTotalWin - this._gameData!.singleWin;
        const fromValue:number = level === 0 ? 0 : this._gameData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue:number = level === this._winLevel ? totalWin : this._gameData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[level + 1].ratio;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            this.playCountUp(fromValue, toValue, duration, preTotalWin),
            () => {
                if(this.playBigWinCountUpSound) {
                    this.playBigWinCountUpSound(level);
                }
            }
        ]);

        return timeline;
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(level, this._winRatios[level]);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        Logger.logDev(`big win playEndingAnimation`);
        let totalWin:number = (<DragonTribeParsedGameData>this._gameData!).avalancheTotalWin;
        this._gameView.playAbortedEndingAnimation(this._winLevel);
        SlotGame.winFieldController.showWinField(this._gameData!.totalWin);
        this._winCountUp.abort(totalWin, isAborted);
    }

    protected isLevelWinTooSmall(level:number):boolean {
        if(level === 0) {
            return false;
        }

        const fromValue:number = this._gameData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue:number = (<DragonTribeParsedGameData>this._gameData!).avalancheTotalWin;

        return (toValue - fromValue) <= (fromValue * 0.1);
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(DragonTribeSoundConfig.BIG_WIN_LOOP);
        SlotGame.sound.fadeAmbience(0, 1000);
    }

    protected stopAllSounds():void {
        SlotGame.sound.fadeAmbience(1, 2000);
        SlotGame.sound.stopEffect(DragonTribeSoundConfig.BIG_WIN_LOOP);
        SlotGame.sound.playEffect((<any>DragonTribeSoundConfig)[`BIG_WIN_END_${this._winLevel}`]);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
    }
}